export const GROUP_TICKET_CONTRACT_VERSION = 2;

export const buildGroupTicketV2ElementsConfigUrl = ({ backendUrl, elementID, overlayDomain }) => {
  const params = new URLSearchParams({
    elementID: String(elementID),
    ticketContractVersion: String(GROUP_TICKET_CONTRACT_VERSION),
  });

  if (overlayDomain) {
    params.set('overlayDomain', overlayDomain);
  }

  return `${backendUrl}/elements-config?${params.toString()}`;
};
